import { Component, Input } from '@angular/core';
import { ProductLeadCard } from '@interfaces';

@Component({
  selector: 'unicon-product-option-chip',
  templateUrl: './product-option-chip.component.html',
})
export class ProductOptionChipComponent {
  @Input() product!: ProductLeadCard;

  protected capitalizeText(value: string): string {
    if (!value) return value;

    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}
